import React from "react";

export const OrigenFiscalSelect = ({ name, value, onChange }) => {
  return (
    <select
      className="select-ejercicio"
      name={name}
      value={value}
      onChange={onChange}
    >
      {/* <option value="C">Consolidado</option> */}
      <option value="I">Ingresos</option>
      <option value="A">Anticipos</option>
      <option value="O">Otros Ingresos</option>
    </select>
  );
};
